'use client';

import React, { startTransition, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { createClient } from '@/lib/supabase/client';
import GoogleAnalytics from '@/components/GoogleAnalytics';
import ConsentMode, { getStoredConsentMode, type ConsentModeValue } from '@/components/ConsentMode';
import { Analytics } from '@vercel/analytics/next';

function applyLightTheme() {
  const root = document.documentElement;
  root.classList.remove('dark');
  root.style.colorScheme = 'light';
}

export default function Providers({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const [consentMode, setConsentMode] = React.useState<ConsentModeValue | null>(null);

  useEffect(() => {
    window.localStorage.removeItem('quorix-theme');
    applyLightTheme();
  }, []);

  useEffect(() => {
    setConsentMode(getStoredConsentMode());

    const syncConsent = (event: Event) => {
      const customEvent = event as CustomEvent<ConsentModeValue>;
      setConsentMode(customEvent.detail ?? getStoredConsentMode());
    };

    window.addEventListener('2xora-consent-mode', syncConsent);
    return () => {
      window.removeEventListener('2xora-consent-mode', syncConsent);
    };
  }, []);

  useEffect(() => {
    const supabase = createClient();
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(() => {
      startTransition(() => {
        router.refresh();
      });
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [router]);

  return (
    <>
      {consentMode === 'all' ? (
        <>
          <GoogleAnalytics data-component-id="src/components/Providers.tsx:58:10" data-component-path="src/components/Providers.tsx" data-component-line="58" data-component-end-line="58" data-component-file="Providers.tsx" data-component-name="GoogleAnalytics" data-component-content="%7B%22elementName%22%3A%22GoogleAnalytics%22%7D" />
          <Analytics data-component-id="src/components/Providers.tsx:59:10" data-component-path="src/components/Providers.tsx" data-component-line="59" data-component-end-line="59" data-component-file="Providers.tsx" data-component-name="Analytics" data-component-content="%7B%22elementName%22%3A%22Analytics%22%7D" />
        </>
      ) : null}
      {children}
      <ConsentMode data-component-id="src/components/Providers.tsx:63:6" data-component-path="src/components/Providers.tsx" data-component-line="63" data-component-end-line="63" data-component-file="Providers.tsx" data-component-name="ConsentMode" data-component-content="%7B%22elementName%22%3A%22ConsentMode%22%7D" onResolved={setConsentMode} />
    </>
  );
}
